import { AlpineComponent } from 'alpinejs';
import PhotoSwipeLightbox from 'photoswipe/lightbox';
import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

const backSvg =
  '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M8.08231 13.1582L3.00316 8.07906L8.08231 2.99992L8.90727 3.82488L5.23646 7.49573L12.5781 7.49573L12.5781 8.66239L5.23647 8.6624L8.90727 12.3332L8.08231 13.1582Z" fill="black"/></svg>';
const forwardSvg =
  '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M7.49581 3L12.575 8.07914L7.49581 13.1583L6.67086 12.3333L10.3417 8.66247L3 8.66248V7.49581L10.3417 7.49581L6.67086 3.82496L7.49581 3Z" fill="black"/></svg>';

const Gallery = (): AlpineComponent => ({
  activeIndex: 0,
  images: null,
  lightbox: null,

  init() {
    this.images = this.$root.querySelectorAll('.gallery__image > a');
    this.lightbox = new PhotoSwipeLightbox({
      gallery: this.$root,
      children: this.images,
      showHideAnimationType: 'fade',
      arrowPrevSVG: backSvg,
      arrowNextSVG: forwardSvg,
      paddingFn: () => {
        return {
          top: 50,
          bottom: 200
        };
      },
      pswpModule: () => import('photoswipe')
    });

    this.lightbox.on('uiRegister', () => {
      this.lightbox.pswp.ui.registerElement({
        name: 'custom-caption typo-copy-small',
        order: 9,
        isButton: false,
        appendTo: 'root',
        html: 'Caption text',
        onInit: (el: HTMLElement) => {
          this.lightbox.pswp.on('change', () => {
            const currSlideElement = this.lightbox.pswp.currSlide.data.element;
            let captionHTML = '';
            if (currSlideElement) {
              const hiddenCaption = currSlideElement.querySelector(
                '.gallery__image-caption'
              );
              if (hiddenCaption) {
                // get caption from element with class hidden-caption-content
                captionHTML = hiddenCaption.innerHTML;
              } else {
                // get caption from alt attribute
                captionHTML = currSlideElement
                  .querySelector('img')
                  .getAttribute('alt');
              }
            }
            el.innerHTML = captionHTML || '';
          });
        }
      });
    });

    this.lightbox.init();

    const slider = this.$root.querySelector('.swiper');
    const swiper = new Swiper(slider, {
      modules: [Navigation],
      slidesPerView: 'auto',
      spaceBetween: 12,
      speed: 450,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      }
    });

    swiper.on('slideChange', () => {
      this.activeIndex = swiper.realIndex;
    });
  },
  openLightbox() {
    this.lightbox.loadAndOpen(this.activeIndex);
  }
});

export default Gallery;
